/**
 * 장례식장 표시명 유틸.
 *
 * `parlors_detail.json` 의 `companyname` 에는 검색 대응용 별칭이 괄호로 병기돼 있다.
 *
 *   고대안암병원장례식장(안암고대병원장례식장, 고대병원장례식장)
 *   교원예움 아산장례식장 (구. 신정장례문화원)
 *
 * 이 값이 그대로 H1 이나 CTA 에 들어가면 모바일에서 여러 줄로 접힌다.
 *
 * ⚠️ 기존 페이지(상세·길찾기 등)는 별칭 병기를 그대로 노출한다. 검색 유입이 목적이라
 * 의도된 것이므로 이 유틸을 거기 끼워넣지 말 것. 임종 안내 랜딩처럼 **문구가 화면을
 * 차지하는 화면에서만** 쓴다.
 */

/**
 * 문자열 끝에서 닫히는 괄호 그룹만 별칭으로 본다.
 *
 * 첫 괄호 이후를 통째로 자르면 이름 중간에 괄호가 있는 곳이 망가진다.
 *   남원 엠지(MG)새마을금고 장례식장 -> "남원 엠지" (X)
 */
const TRAILING_ALIAS = /\s*[(（][^)）]*[)）]\s*$/;

/** 이름 앞에 붙는 법인격 표기. 별칭이 아니라 접두사라 뒤쪽을 남겨야 한다. */
const LEADING_ENTITY = /^\s*[(（](주|재|사|유|합)[)）]\s*/;

/**
 * 병기된 별칭을 제거한 표시용 장례식장명.
 *
 * @param companyname parlors_detail.json 의 companyname
 * @returns 표시용 이름. 입력이 문자열이 아니거나 결과가 비면 원본/빈 문자열
 */
export function toParlorDisplayName(
  companyname: string | undefined | null
): string {
  if (typeof companyname !== "string") return "";
  const stripped = companyname
    .replace(LEADING_ENTITY, "")
    .replace(TRAILING_ALIAS, "")
    .trim();
  // 이름 전체가 괄호였던 경우 빈 문자열이 되므로 원본으로 되돌린다
  return stripped || companyname.trim();
}
